import { defineStore } from 'pinia';

import { fetchWrapper } from '@/helpers/fetch-wrapper';


const baseUrl = `${process.env.VUE_APP_API_URL}/ecommerce/products`;

export const useProductStore = defineStore({
    id: 'products',
    state: () => ({
        products: [],
        product: {

        }
    }),
    actions: {
        async fetchAll() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}?account_id=` + accountId + '&type=treatment_plan');
            this.products = response.data;
        },

        async fetchOne(productId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            await fetchWrapper.get(`${baseUrl}/` + productId + '?account_id=' + accountId, null).then(response => {
                this.product = response.data;
            })
        }
    }
});
